import api from "services/backendService";

const SET_CONFIGURATION = "SET_CONFIGURATION";

const initialState = {};

const configuration = (state = initialState, action) => {
    switch (action.type) { // NOSONAR
        case SET_CONFIGURATION:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default configuration;

export const initConfigurationAsync = (dispatch) => {
    return new Promise((resolve) => {
        api.getConfigurationAsync().then((response) => {
            dispatch({
                type: SET_CONFIGURATION,
                payload: response,
            });
            resolve();
        });
    });
};
